import { captureException } from '@sentry/vue';
import {
  AsyncStorage,
  experimental_createPersister,
} from '@tanstack/query-persist-client-core';
import { QueryClient } from '@tanstack/vue-query';
import { get, set, del } from 'idb-keyval';

function createStorageWithFallback(): AsyncStorage<string> {
  const indexedDBAvailable = (() => {
    try {
      return !!window.indexedDB;
    } catch (e) {
      captureException('IndexedDB not available');
      return false;
    }
  })();

  if (indexedDBAvailable) {
    return {
      getItem: async (key: string) => {
        return get(key);
      },
      setItem: async (key: string, value: any) => {
        set(key, value);
      },
      removeItem: async (key: string) => {
        del(key);
      },
    };
  }
  return {
    getItem: (key: string) => localStorage.getItem(key),
    setItem: (key: string, value: any) => localStorage.setItem(key, value),
    removeItem: (key: string) => localStorage.removeItem(key),
  };
}

const storage = createStorageWithFallback();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      gcTime: 1000 * 60 * 10,
      retry: 1,
      persister: experimental_createPersister({
        storage: storage,
        maxAge: 1000 * 60 * 60 * 12, // 12 hours
      }),
    },
  },
});

export default queryClient;
